import React, { useState, useRef, useEffect } from "react";
import { DropdownIcon } from "../../../fixedassetelements/button/Button";
import styles from "./CustomDropdown.module.css";

const CustomDropdown = ({
  label,
  required = false,
  value = "",
  onChange,
  options = [],
  placeholder = "Select Option",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.fieldGroup} ref={dropdownRef}>
      {label && (
        <label className={styles.label}>
          {required && <span className={styles.required}>* </span>}
          {label}
        </label>
      )}

      <div className={styles.dropdownContainer}>
        <div className={styles.inputWrapper} onClick={toggleDropdown}>
          <input
            type="text"
            className={styles.input}
            placeholder={placeholder}
            value={value}
            readOnly
          />
        </div>

        <div className={styles.iconWrapper}>
          <DropdownIcon />
        </div>

        {isOpen && (
          <div className={styles.dropdownMenu}>
            {options.length > 0 ? (
              options.map((option, index) => (
                <div
                  key={index}
                  className={styles.dropdownItem}
                  onClick={() => handleSelect(option)}
                >
                  {option}
                </div>
              ))
            ) : (
              <div className={styles.dropdownItem}>No options available</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomDropdown;
